import { useEffect, useState } from "react";
import { trackAmplitudeEvent } from "../../amplitude";
import { isEligibleForAnnouncement, todayString } from "./todaysPlanService";
import { localKey, readLocal, writeLocal } from "./todaysPlanStorage";

// isBlocked holds it back while another dashboard modal is open, like the app's announcement slot.
export default function useTodaysPlanAnnouncement({ accountCreatedAt, isBlocked, username }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if(!accountCreatedAt) return;

    const seenKey = localKey("AnnouncementSeen", username);
    if(readLocal(seenKey)) return;

    // Held back for another modal: it stays owed, since using the plan meanwhile would make the user ineligible.
    const pendingKey = localKey("AnnouncementPending", username);
    const isEligible = readLocal(pendingKey) || isEligibleForAnnouncement(readLocal(localKey("FirstViewed", username)), accountCreatedAt, todayString());
    if(isEligible && isBlocked) {
      writeLocal(pendingKey, true);
      return;
    }

    // Saved for ineligible users too, so they never qualify later.
    writeLocal(seenKey, true);
    if(!isEligible) return;

    setIsVisible(true);
    trackAmplitudeEvent("todays_plan_announcement_viewed");
  }, [accountCreatedAt, isBlocked, username]);

  const acknowledge = () => trackAmplitudeEvent("todays_plan_announcement_button_tapped");

  return { acknowledge, close: () => setIsVisible(false), isVisible };
}
